import { useEffect, useState } from "react"

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Text,
} from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"

interface SideMenuAccordionProps {
  isSidebarOpen: boolean
  menuTitle: string
  menuIcon: JSX.Element
  menuItems: { title: string; path: string }[]
}
const SideMenuAccordion = (props: SideMenuAccordionProps) => {
  const { isSidebarOpen, menuTitle, menuIcon, menuItems } = props
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (!isSidebarOpen) setOpen(false)
  }, [isSidebarOpen])
  return (
    <Accordion allowMultiple allowToggle index={open ? [0] : []} mt={4}>
      <AccordionItem border='none' p={0} minH={10}>
        {({ isExpanded }) => (
          <Box>
            <Box display='flex' pb={3}>
              <AccordionButton
                onClick={() => setOpen(!open)}
                textAlign='left'
                alignItems='center'
                p={0}
                w='full'
                m={0}
                justifyContent={isSidebarOpen ? "flex-start" : "center"}
                _hover={{}}
                flex='1'
              >
                {menuIcon}
                {isSidebarOpen ? (
                  <Box display='flex' alignItems='center' gap={2}>
                    <Text color='white' fontWeight={500} ml={2} pl={1.5}>
                      {menuTitle}
                    </Text>
                    <AccordionIcon
                      transform={isExpanded ? "rotate(180deg)" : "rotate(0deg)"}
                      transition='transform 0.2s'
                    />
                  </Box>
                ) : (
                  ""
                )}
              </AccordionButton>
            </Box>
            <AccordionPanel p='0'>
              {menuItems.map((item) => (
                <Button
                  key={item.title}
                  variant='ghost'
                  textAlign='left'
                  alignItems='center'
                  p={0}
                  ml='14px'
                  w='full'
                  _hover={{
                    textDecoration: "underline",
                  }}
                  color='white'
                  justifyContent={isSidebarOpen ? "flex-start" : "center"}
                  onClick={(event) => {
                    event.stopPropagation()
                    navigate(item.path)
                  }}
                >
                  {isSidebarOpen ? (
                    <Text color='white' fontWeight={500} ml={4} pl={1.5}>
                      {item.title}
                    </Text>
                  ) : (
                    ""
                  )}
                </Button>
              ))}
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>
    </Accordion>
  )
}

export default SideMenuAccordion
